import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import { BqButton, BqInput, BqSlider, BqRadio, BqRadioGroup } from '@beeq/react'
import {
  FilterTagWrapper,
  FooterWrapper,
  FilterTagColumnWrapper,
  AdvancedSearchFilterLabel,
  AdvancedSearchFilterPercentajeTitle,
  AdvancedSearchFilter,
  AdvancedSearchFilterSelect,
  StyledBqCheckbox,
  StyledBqOption,
  StyledBqDivider,
  StyledFieldsWrapper
} from './styles'
import { Text } from '../../constants/TextConstants'
import AppliedFiltersTags from './AppliedFiltersTags'
import { removedValueObj } from '../../utils/utils'
import { useSave } from '../../Context/saveContext'
import { PERMISSION_CODES } from '../../constants/permissions'

export default function AdvancedSearch({
  advancedSearchVisible,
  closeAdvancedSearch,
  advancedSearchOptions,
  resetAdvancedSearchFilterData,
  handleAdvancedSearch,
  advancedSearchFilter
}) {
  const [advancedSearchConfig, setadvancedSearchConfig] = useState([{}])
  const { userPermissions } = useSave()
  const maxDate = moment().format('YYYY-MM-DD')
  const minDate = moment().subtract(100, 'years').format('YYYY-MM-DD')

  useEffect(() => {
    setadvancedSearchConfig([
      { title: Text.AdvancedSearchPeopleStatusLabel, name: 'status', optionsList: ['Active', 'Archived'] },
      {
        title: Text.Country,
        name: 'country',
        placeholder: `${Text.Select} ${Text.Country}`,
        optionsList: advancedSearchOptions.country
      },
      {
        title: Text.DeliveryLocation,
        name: 'DU',
        placeholder: Text.SelectLocation,
        optionsList: advancedSearchOptions.DU
      },
      {
        title: Text.Grade,
        name: 'grade',
        placeholder: `${Text.Select} ${Text.Grade}`,
        optionsList: advancedSearchOptions.grade
      },
      {
        title: Text.CoreSkills,
        name: 'core_skill',
        placeholder: `${Text.Select} ${Text.CoreSkill}`,
        optionsList: advancedSearchOptions.coreSkill
      },
      {
        title: Text.Discipline,
        name: 'discipline',
        placeholder: `${Text.Select} ${Text.Discipline}`,
        optionsList: advancedSearchOptions.discipline
      },
      { title: Text.SkillsQualifications },
      {
        title: Text.SpokenLanguages,
        name: 'spokenLanguages',
        placeholder: Text.Select,
        optionsList: advancedSearchOptions.languages
      },
      {
        title: Text.Certifications,
        name: 'certification',
        placeholder: Text.Select,
        optionsList: advancedSearchOptions.certifications
      },
      {
        title: Text.ProgramingLanguages,
        name: 'programmingLanguages',
        placeholder: Text.Select,
        optionsList: advancedSearchOptions.programmingLanguages
      },
      { title: Text.DB, name: 'databases', placeholder: Text.Select, optionsList: advancedSearchOptions.databases },
      {
        title: Text.ToolsTechniques,
        name: 'toolTechnique',
        placeholder: Text.Select,
        optionsList: advancedSearchOptions.toolsAndTechniques
      },
      { title: Text.UpdateCompletions },
      {
        title: Text.LastUpdateFrom,
        name: 'lastUpdateFrom',
        optionsList: localAdvancedSearchFilterData.lastUpdateFrom || ''
      },
      {
        title: Text.LastUpdateTo,
        name: 'lastUpdateTo',
        optionsList: localAdvancedSearchFilterData.lastUpdateTo || ''
      },
      { title: `% ${Text.CompletionTo}`, name: 'completion' }
    ])
  }, [advancedSearchOptions])
  // localAdvancedSearchFilterData state is used to keep the state until the Apply button is pressed
  const [localAdvancedSearchFilterData, setLocalAdvancedSearchFilterData] = useState(advancedSearchFilter)

  useEffect(() => {
    setLocalAdvancedSearchFilterData(advancedSearchFilter)
  }, [advancedSearchFilter])

  const onChangeHandler = (value, name) => {
    const newObject = { ...removedValueObj(value, name, localAdvancedSearchFilterData), [name]: value }
    setLocalAdvancedSearchFilterData(newObject)
  }
  const onClickApplyHandler = () => {
    handleAdvancedSearch(localAdvancedSearchFilterData)
    closeAdvancedSearch()
  }

  const onClickClearAllHandler = () => {
    resetAdvancedSearchFilterData()
    closeAdvancedSearch()
  }

  return (
    <>
      <AdvancedSearchFilter
        placement='right'
        open={advancedSearchVisible}
        close-on-click-outside
        enableBackdrop
        close-on-esc
        data-testid='advanced-search-filter-drawer'
        onBqClose={closeAdvancedSearch}>
        <div slot='title' data-testid='advanced-search-filter-drawer-title'>
          {Text.AdvancedSearchTitle}
        </div>
        <FilterTagColumnWrapper>
          <span>{Text.AdvancedSearchAppliedFilters}</span>
          <FilterTagWrapper>
            <AppliedFiltersTags
              filterData={localAdvancedSearchFilterData}
              setFilterData={setLocalAdvancedSearchFilterData}
            />
          </FilterTagWrapper>
          <StyledFieldsWrapper>
            {advancedSearchConfig.map((field, index) => {
              const fieldValue = localAdvancedSearchFilterData[field.name]
              return (
                <React.Fragment key={index}>
                  {[
                    'country',
                    'DU',
                    'grade',
                    'core_skill',
                    'discipline',
                    'spokenLanguages',
                    'certification',
                    'programmingLanguages',
                    'databases',
                    'toolTechnique'
                  ].includes(field.name) && (
                    <AdvancedSearchFilterSelect
                      multiple
                      disableClear
                      name={field.name}
                      placeholder={field.placeholder}
                      data-testid={`advanced-search-filter-select-${field.name}`}
                      keepOpenOnSelect
                      value={fieldValue.length === 0 ? '[]' : JSON.stringify(fieldValue)}
                      onBqSelect={(e) => {
                        e.stopPropagation()
                        onChangeHandler(e.detail.value, field.name)
                      }}>
                      <div slot='label' style={{ display: 'flex', flex: '1 1 0%' }}>
                        <label style={{ display: 'flex', alignItems: 'center', flexGrow: 1 }}>{field.title}</label>
                        <span
                          data-testid={`advanced-search-filter-${field.label}-selected`}
                          style={{ color: 'var(--bq-text--secondary)' }}>
                          {`(${fieldValue.length}) Selected`}
                        </span>
                      </div>
                      {field.optionsList &&
                        field.optionsList.map((item, index) => {
                          return (
                            <StyledBqOption key={index} value={item}>
                              <StyledBqCheckbox
                                name='name'
                                checked={localAdvancedSearchFilterData[field.name].includes(item)}
                                value={item}
                              />
                              {item}
                            </StyledBqOption>
                          )
                        })}
                    </AdvancedSearchFilterSelect>
                  )}
                  {['lastUpdateFrom', 'lastUpdateTo'].includes(field.name) && (
                    <BqInput
                      name={field.name}
                      type='date'
                      value={fieldValue === '' ? '' : moment(fieldValue, 'yyyy-MM-dd')._i}
                      max={maxDate}
                      min={field.name === 'lastUpdateFrom' ? minDate : localAdvancedSearchFilterData.lastUpdateFrom}
                      disableClear
                      data-testid={`advanced-search-filter-date-${field.name}`}
                      onBqChange={(e) => onChangeHandler(e.detail.value, field.name)}>
                      <div slot='label'>
                        <label data-testid={`advanced-search-filter-${field.title}-label`}>{field.title}</label>
                      </div>
                    </BqInput>
                  )}
                  {['completion'].includes(field.name) && (
                    <>
                      <AdvancedSearchFilterPercentajeTitle data-testid='advanced-search-filter-completion-percentaje'>
                        {Text.AdvancedSearchProfileCompletionPercentaje}
                      </AdvancedSearchFilterPercentajeTitle>
                      <BqSlider
                        min={0}
                        max={100}
                        type='range'
                        value={JSON.stringify(localAdvancedSearchFilterData.completion)}
                        enable-value-indicator
                        onBqChange={(event) => {
                          if (Array.isArray(event.detail.value)) {
                            onChangeHandler(event.detail.value, 'completion')
                          }
                        }}
                        data-testid={`advanced-search-filter-slider-${field.name}`}
                      />
                    </>
                  )}
                  {['status'].includes(field.name) &&
                    userPermissions.includes(PERMISSION_CODES.viewArchivedProfiles.code) && (
                      <BqRadioGroup
                        backgroundOnHover
                        name={field.name}
                        orientation='horizontal'
                        value={localAdvancedSearchFilterData.status}
                        data-testid='people-status-filter-select'
                        onBqChange={(e) =>
                          setLocalAdvancedSearchFilterData({
                            ...localAdvancedSearchFilterData,
                            status: e.detail.value
                          })
                        }>
                        <label slot='label'>{Text.AdvancedSearchPeopleStatusLabel}</label>
                        {field.optionsList.map((item) => {
                          return (
                            <BqRadio name={item} key={item} value={item}>
                              {item}
                            </BqRadio>
                          )
                        })}
                      </BqRadioGroup>
                  )}
                  {!field.name && (
                    <div>
                      <AdvancedSearchFilterLabel data-testid={`advanced-search-filter-${field.name}-category`}>
                        {field.title}
                      </AdvancedSearchFilterLabel>
                    </div>
                  )}
                </React.Fragment>
              )
            })}
          </StyledFieldsWrapper>
        </FilterTagColumnWrapper>
        <StyledBqDivider slot='footer-divider' strokeColor='ui--secondary' strokeThickness={1} />
        <div slot='footer'>
          <FooterWrapper>
            <BqButton
              data-testid='advanced-search-filter-cancel-button'
              variant='ghost'
              border='s'
              block
              appearance='secondary'
              onBqClick={onClickClearAllHandler}>
              {Text.AdvancedSearchCancelButton}
            </BqButton>

            <BqButton
              data-testid='advanced-search-filter-apply-button'
              border='s'
              block
              onBqClick={onClickApplyHandler}>
              {Text.AdvancedSearchApplyButon}
            </BqButton>
          </FooterWrapper>
        </div>
      </AdvancedSearchFilter>
    </>
  )
}

AdvancedSearch.propTypes = {
  advancedSearchVisible: PropTypes.bool,
  closeAdvancedSearch: PropTypes.func.isRequired,
  advancedSearchOptions: PropTypes.object,
  handleAdvancedSearch: PropTypes.func.isRequired,
  resetAdvancedSearchFilterData: PropTypes.func.isRequired,
  advancedSearchFilter: PropTypes.object
}
